// Modules
import React from 'react';

// Styles
import "./ResultFilterByHotel.sass"

// Interfaces
import {State, Country} from 'Interfaces/FilterResultInterface';

// Components
import MvCheckBox from 'Generic/MvCheckBox';

type Props ={
    area: Country[];
    selectedCities: string[];
    onSelect: (id: string, city: string) => void
};

class ResultFilterByHotel extends React.Component<Props, {}> {

    render() {
        let locationList = this.props.area;
        let locationView = locationList.map(item => {
        let state = item.states.map((state: State) => {
        let cities = state.cities.map((city: string) => {
            return (
                <div className="hotel" tabIndex={0} onKeyDown={(e) => e.keyCode === 32 ? this.props.onSelect("area", city) : false} aria-label={city + state.name}>
                <MvCheckBox
                    onChange={() => {this.props.onSelect("area", city)}}
                    checked={this.props.selectedCities.indexOf(city) > -1}
                    label={city}
                    id={city}
                    labelStyle={{ fontSize: "12px", fontWeight: 400}}
                    tabIndex={-1}
                />
                </div>

                );
            });
            return (
                <React.Fragment>
                    {cities}
                </React.Fragment>


            );
        });
        return (

            <div className="single-country">
                <div className="country-text">{item.continent} - {item.name}</div>
                {state}
            </div>

        );
        });
        return locationView;
    }
}

export default ResultFilterByHotel;
